import { MHColours } from '../../constants/theme';

export const DS = {
  deepTeal: MHColours.mhDeepTeal,
  softBlack: '#242829',
  inkSecondary: '#5A5E5F',
  coolMint: '#CAE9E4',
  surfaceTint: '#E7E2D9',
  surfaceCanvas: '#F1EDE6',
  dawn: '#EBB194',
  dawnSurface: '#F0E1D6',
  hairline: 'rgba(36, 40, 41, 0.12)',
  surfaceRaised: '#FFFFFF',
  radiusLg: '20px',
  shadowSm:
    '0 2px 8px rgba(36, 40, 41, 0.05), 0 1px 2px rgba(36, 40, 41, 0.04)',
  fontDisplay: '"Mona Sans", "Inter", system-ui, sans-serif',
  fontBody: '"Lato", "Helvetica Neue", system-ui, sans-serif',
  amber: '#E9A23A',
  muted: '#8C8F8F',
  amberDark: '#7A5800',
  amberLight: '#FDF5EE',
  amberBorder: '#f0d0a0',
  amberHover: '#faecd8',
};

export const tealButtonSx = {
  fontFamily: DS.fontBody,
  fontWeight: 700,
  color: DS.surfaceRaised,
  backgroundColor: DS.deepTeal,
  borderRadius: '999px',
  textTransform: 'none' as const,
  '&:hover': { filter: 'brightness(0.96)', backgroundColor: DS.deepTeal },
};
